// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Available solution actions
export const SOLUTION_ACTIONS_KEY = {
  GET_SOLUTION_BY_ID: 'GET_SOLUTION_BY_ID',
  SET_CURRENT_SOLUTION: 'SET_CURRENT_SOLUTION',
  RESET_CURRENT_SOLUTION: 'RESET_CURRENT_SOLUTION',
};
